import { useTranslations } from 'next-intl'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/styles'
import { NAVBAR_TEST_IDS } from '@/lib/test-ids'
import styles from './MobileMenu.module.css'

interface MobileMenuToggleProps {
	onClick: () => void
	isMobileMenuOpen: boolean
}

export const MobileMenuToggle = ({ onClick, isMobileMenuOpen }: MobileMenuToggleProps) => {
	const t = useTranslations('navbar')
	return (
		<Button
			variant="primaryLink"
			size="none"
			className={cn('lg:hidden', isMobileMenuOpen && styles.active, styles['hamburger-menu'])}
			onClick={onClick}
			data-test-id={NAVBAR_TEST_IDS.MOBILE_MENU_BUTTON}
			aria-label={t('toggle')}
		>
			<span className={styles['hamburger-menu__lines']} />
		</Button>
	)
}
